import { ResponsiveImage, Video } from '~/graphql/fragments'

export const queryProjects = /* GraphQL */ `
  ${ResponsiveImage}
  ${Video}
  query Projects(
    $locale: SiteLocale
    $first: IntType = 100
    $skip: IntType
    $excludeSlugs: [String]
    $allInLocation: [ItemId]
    $publishTranslation: BooleanType = true
  ) {
    _allProjectsMeta(
      locale: $locale
      filter: {
        publishTranslation: { eq: $publishTranslation }
        locations: { allIn: $allInLocation }
        slug: { notIn: $excludeSlugs }
      }
    ) {
      count
    }
    allProjects(
      locale: $locale
      first: $first
      skip: $skip
      filter: {
        publishTranslation: { eq: $publishTranslation }
        locations: { allIn: $allInLocation }
        slug: { notIn: $excludeSlugs }
      }
      orderBy: year_DESC
    ) {
      __typename
      _modelApiKey
      id
      locations {
        id
        title
      }
      video {
        ...Video
      }
      title
      year
      metadata
      slug
      publishTranslation
    }
  }
`
